import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from '@Components/Button/Button';

import BaseDialogLayoutHeader from './BaseDialogLayoutHeader';
import BaseDialogLayoutContent from './BaseDialogLayoutContent';
import BaseDialogLayoutFooter from './BaseDialogLayoutFooter';

import './BaseDialogLayout.custom.scss';
import './BaseDialogLayout.theme.scss';

function BaseDialogLayout(props) {
  const { size, style, closeBtn, selfClose, className, resizable } = props;

  const closeButton = closeBtn ? (
    <Button
      buttonConfig={{
        type: 'link',
        size: 'sm',
        className: 'els-btn-modal-close',
        iconOnly: true,
        ariaLabel: 'Close',
        e2eName: 'modal-close',
      }}
      iconConfig={{ name: 'delete', size: 'tiny' }}
      onClick={selfClose}
    />
  ) : null;

  return (
    <section
      role="dialog"
      tabIndex="-1"
      style={style}
      className={classnames('base-dialog-layout', `base-dialog-layout-${size}`, resizable && 'base-dialog-layout-resizable', className)}>
      {closeButton}
      <BaseDialogLayoutHeader {...props} />
      <BaseDialogLayoutContent {...props} />
      <BaseDialogLayoutFooter {...props} />
    </section>
  );
}

BaseDialogLayout.defaultProps = {
  closeBtn: true,
  size: 'lg',
  resizable: false,
};

BaseDialogLayout.propTypes = {
  size: PropTypes.oneOf(['fit', 'sm', 'md', 'lg', 'xl']),
  style: PropTypes.object,
  closeBtn: PropTypes.bool,
  className: PropTypes.string,
  selfClose: PropTypes.func,
  resizable: PropTypes.bool,
};

export default BaseDialogLayout;
